module.exports = __webpack_public_path__ + "static/media/peroni-challenge-512.f0c24fe9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/peroni-challenge-512.png
// module id = 783
// module chunks = 0